import FormFieldCheck from '@/store/Form/requestFormFieldCheck';
import myApi from '@/gavnoCode/ApiHandler';

const searchCalcIndex = (a, b, array, calcSumm) => {
  let out = 0;
  if (calcSumm === array[a].value) {
    out = a;
  } else if (calcSumm === array[b].value) {
    out = b;
  } else {
    let arrayHalf = Math.ceil((b + a) / 2);
    if (calcSumm > array[arrayHalf].value) {
      a = arrayHalf;
      b = b - 1;
      return searchCalcIndex(a, b, array, calcSumm);
    } else {
      b = arrayHalf;
      a += 1;
      return searchCalcIndex(a, b, array, calcSumm);
    }
  }
  return out
};

/**
 *
 * @param arr -любой массив который нужно потрогать, но помни! отсортируй его заранее!
 * @param needle - что надо найти в массиве
 * @param compareFn - функция тобой придуманная, для сравнения.
 * !!!Если нашлось нужное вернуть 0, если в массиве меньше искомого -1, иначе 1!!!
 * @param start - само отработает, не трогай
 * @param end - само отработает, не трогай
 * @returns {number|number|number|*} вернет индекс найденного в массиве.
 */
const handmadeSearch = (arr = [], compareFn, start = 0, end = arr.length - 1) => {
  if (!Array.isArray(arr)) {
    console.log('ей! искать только в массиве, а не вот в этом');
    return -404;
  }
  if (Object.prototype.toString.call(compareFn) !== '[object Function]') {
    console.log('ей! фунция для сравнения нужна. где она?');
    return -404;
  }

  const mid = Math.floor((start + end) / 2);
  if (arr[mid] === undefined) {
    // console.log('убежали за пределы массива');
    return -300;
  }
  //сравниваем по функции которую дали
  const resultCompare = compareFn(arr[mid]);

  if (typeof resultCompare !== 'number') {
    console.log('функция возврашает не число, смотри описание, зря что ли писал?');
    return -404;
  }

  //нашлось
  if (resultCompare === 0) {
    return mid;
  }

  //не нашли, но пытались
  if (start > mid) {
    return -1;
  }

  return resultCompare > 0
    ? handmadeSearch(arr, compareFn, start, mid - 1)
    : handmadeSearch(arr, compareFn, mid + 1, end);
}

const insuranseCost = 0.1; /*хардкор стоимость страховки*/
/**
 * формат хранения данных по возможной страховке
 * @param base сумма которую выбрал пользователь
 * @param insuranse сумма со страховкой от базового значения
 * @returns {{insuranseAmount: number, baseAmount: number}}
 */
const posibleDealWithInsuranceItem = (base = 0, insuranse = 0) => {
  return {
    baseAmount: base,
    insuranseAmount: insuranse
  }
}

const posibleDealWithInsurance = () => {
  //Хреновый, но справочник продуктов сторновки от стоимости займа
  const min = 2000;
  const max = 15000;
  let out = {};
  let calcInsurance = 0;
  for (let i = min; i < max; i += 1000) {
    calcInsurance = i + (i * insuranseCost);
    if (calcInsurance < max) {
      out[i] = posibleDealWithInsuranceItem(i, calcInsurance);
      out[calcInsurance] = posibleDealWithInsuranceItem(i, calcInsurance);
    }
  }
  return out;
}

const defaultRequriedFieldWorkData = () => {
  return {code: 1, msg: 'обязательное поле', ShowError: false, disable: false}
}

const getDefaultState = () => {
  return {
    sendData: {
      AVERAGE_EXPENSES_PER_MONTH: '',
      AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS: '',
      BIRTHDAY: '',
      BIRTHPLACE: '',
      CALC_SUMM: '',
      CALC_WEEK: 52,
      CAR_NUMBER: '',
      CONST_INCOME: '',
      CREDHISTORY_RADIO: '',
      EDUCATION: '',
      MARITAL_STATUS: '',
      MINOR_CHILDREN: false,
      EMAIL: '',
      EMAILreq: '',
      EXPER_RADIO: '',
      FIRST_NAME: '',
      GENDER: '',
      IS_ADDRESS_COINCIDES: 'N',
      IS_I_CERTIFY_REGISTRATION: 'Y',
      IS_I_CERTIFY_MARKETING: 'Y',
      IS_ASSIGNMENT_RIGHT: true,
      LAST_NAME: '',
      MEETING_DATE: '',
      MEETING_HOUR: '',
      OTHER_SOURCES_OF_INCOME: 0,
      PASSPORT_DATE: '',
      PASSPORT_DEP: '',
      PASSPORT_DEP_CODE: '',
      PASSPORT_NUMBER: '',
      PASSPORT_SERIES: '',
      PHONE: '+7 (',
      PRODUCT_ID: 'S',
      REGISTRATION_ADDRESS: '',
      REGISTRATION_ADDRESS_DADATA: {
        data: {
          postal_code: '',
          country: '',
          country_iso_code: '',
          federal_district: '',
          region_fias_id: '',
          region_kladr_id: '',
          region_iso_code: '',
          region_with_type: '',
          region_type: '',
          region_type_full: '',
          region: '',
          area_fias_id: '',
          area_kladr_id: '',
          area_with_type: '',
          area_type: '',
          area_type_full: '',
          area: '',
          city_fias_id: '',
          city_kladr_id: '',
          city_with_type: '',
          city_type: '',
          city_type_full: '',
          city: '',
          city_area: '',
          city_district_fias_id: '',
          city_district_kladr_id: '',
          city_district_with_type: '',
          city_district_type: '',
          city_district_type_full: '',
          city_district: '',
          settlement_fias_id: '',
          settlement_kladr_id: '',
          settlement_with_type: '',
          settlement_type: '',
          settlement_type_full: '',
          settlement: '',
          street_fias_id: '',
          street_kladr_id: '',
          street_with_type: '',
          street_type: '',
          street_type_full: '',
          street: '',
          house_fias_id: '',
          house_kladr_id: '',
          house_type: '',
          house_type_full: '',
          house: '',
          block_type: '',
          block_type_full: '',
          block: '',
          flat_type: '',
          flat_type_full: '',
          flat: '',
          flat_area: '',
          square_meter_price: '',
          flat_price: '',
          postal_box: '',
          fias_id: '',
          fias_code: '',
          fias_level: '',
          fias_actuality_state: '',
          kladr_id: '',
          geoname_id: '',
          capital_marker: '',
          okato: '',
          oktmo: '',
          tax_office: '',
          tax_office_legal: '',
          timezone: '',
          geo_lat: '',
          geo_lon: '',
          beltway_hit: '',
          beltway_distance: '',
          metro: '',
          qc_geo: '',
          qc_complete: '',
          qc_house: '',
          history_values: '',
          unparsed_parts: '',
          source: '',
          qc: ''
        }
      },
      RESIDENTIAL_ADDRESS: '',
      RESIDENTIAL_ADDRESS_DADATA: {
        data: {
          postal_code: '',
          country: '',
          country_iso_code: '',
          federal_district: '',
          region_fias_id: '',
          region_kladr_id: '',
          region_iso_code: '',
          region_with_type: '',
          region_type: '',
          region_type_full: '',
          region: '',
          area_fias_id: '',
          area_kladr_id: '',
          area_with_type: '',
          area_type: '',
          area_type_full: '',
          area: '',
          city_fias_id: '',
          city_kladr_id: '',
          city_with_type: '',
          city_type: '',
          city_type_full: '',
          city: '',
          city_area: '',
          city_district_fias_id: '',
          city_district_kladr_id: '',
          city_district_with_type: '',
          city_district_type: '',
          city_district_type_full: '',
          city_district: '',
          settlement_fias_id: '',
          settlement_kladr_id: '',
          settlement_with_type: '',
          settlement_type: '',
          settlement_type_full: '',
          settlement: '',
          street_fias_id: '',
          street_kladr_id: '',
          street_with_type: '',
          street_type: '',
          street_type_full: '',
          street: '',
          house_fias_id: '',
          house_kladr_id: '',
          house_type: '',
          house_type_full: '',
          house: '',
          block_type: '',
          block_type_full: '',
          block: '',
          flat_type: '',
          flat_type_full: '',
          flat: '',
          flat_area: '',
          square_meter_price: '',
          flat_price: '',
          postal_box: '',
          fias_id: '',
          fias_code: '',
          fias_level: '',
          fias_actuality_state: '',
          kladr_id: '',
          geoname_id: '',
          capital_marker: '',
          okato: '',
          oktmo: '',
          tax_office: '',
          tax_office_legal: '',
          timezone: '',
          geo_lat: '',
          geo_lon: '',
          beltway_hit: '',
          beltway_distance: '',
          metro: '',
          qc_geo: '',
          qc_complete: '',
          qc_house: '',
          history_values: '',
          unparsed_parts: '',
          source: '',
          qc: ''
        }
      },
      tinkoffE2C_cardSelected: {},
      tinkoffA2C_bankSelected: {
        finderStr: "",
        img: "",
        memberId: "",
        memberName: "",
        memberNameRus: ""
      },
      SECOND_NAME: '',
      WORK_JOB: '',
      WORK_TITLE: '',
      WORK_TITLE_GIG_DATA: {},
      WORK_JOB_DADATA: {
        value: "", unrestricted_value: "", data: {
          kpp: "",
          capital: null,
          invalid: null,
          management: {name: "", post: "", disqualified: null},
          founders: null,
          managers: null,
          predecessors: null,
          successors: null,
          branch_type: "",
          branch_count: 0,
          source: null,
          qc: null,
          hid: "",
          type: "",
          state: {status: "", code: null, actuality_date: 0, registration_date: 0, liquidation_date: null},
          opf: {type: "", code: "", full: "", short: ""},
          name: {full_with_opf: "", short_with_opf: "", latin: null, full: "", short: ""},
          inn: "",
          ogrn: "",
          okpo: "",
          okato: "",
          oktmo: "",
          okogu: "",
          okfs: "",
          okved: "",
          okveds: null,
          authorities: null,
          documents: null,
          licenses: null,
          finance: {
            tax_system: null,
            income: null,
            expense: null,
            revenue: null,
            debt: null,
            penalty: null,
            year: null
          },
          address: {
            value: "", unrestricted_value: "", invalidity: null, data: {
              postal_code: "",
              country: "",
              country_iso_code: "",
              federal_district: "",
              region_fias_id: "",
              region_kladr_id: "",
              region_iso_code: "",
              region_with_type: "",
              region_type: "",
              region_type_full: "",
              region: "",
              area_fias_id: null,
              area_kladr_id: null,
              area_with_type: null,
              area_type: null,
              area_type_full: null,
              area: null,
              city_fias_id: "",
              city_kladr_id: "",
              city_with_type: "",
              city_type: "г",
              city_type_full: "",
              city: "",
              city_area: null,
              city_district_fias_id: null,
              city_district_kladr_id: null,
              city_district_with_type: "",
              city_district_type: "",
              city_district_type_full: "",
              city_district: "",
              settlement_fias_id: null,
              settlement_kladr_id: null,
              settlement_with_type: null,
              settlement_type: null,
              settlement_type_full: null,
              settlement: null,
              street_fias_id: "",
              street_kladr_id: "",
              street_with_type: "",
              street_type: "",
              street_type_full: "",
              street: "",
              stead_fias_id: null,
              stead_cadnum: null,
              stead_type: null,
              stead_type_full: null,
              stead: null,
              house_fias_id: "",
              house_kladr_id: "",
              house_cadnum: "",
              house_flat_count: null,
              house_type: "",
              house_type_full: "",
              house: "",
              block_type: null,
              block_type_full: null,
              block: null,
              entrance: null,
              floor: null,
              flat_fias_id: null,
              flat_cadnum: null,
              flat_type: null,
              flat_type_full: null,
              flat: null,
              flat_area: "",
              square_meter_price: "",
              flat_price: null,
              room_fias_id: null,
              room_cadnum: null,
              room_type: null,
              room_type_full: null,
              room: null,
              postal_box: null,
              fias_id: "",
              fias_code: "",
              fias_level: "",
              fias_actuality_state: "",
              kladr_id: "",
              geoname_id: "",
              capital_marker: "",
              okato: "",
              oktmo: "",
              tax_office: "",
              tax_office_legal: "",
              timezone: "",
              geo_lat: "",
              geo_lon: "",
              beltway_hit: null,
              beltway_distance: null,
              metro: [{name: "", line: "", distance: 0}],
              divisions: null,
              qc_geo: "",
              qc_complete: null,
              qc_house: null,
              history_values: null,
              unparsed_parts: null,
              source: "",
              qc: ""
            }
          },
          phones: null,
          emails: null,
          ogrn_date: 0,
          okved_type: "",
          employee_count: null
        }
      },
      WORK_JOB_ADRESS: '',
      WORK_JOB_ADRESS_DADATA: {
        data: {
          postal_code: '',
          country: '',
          country_iso_code: '',
          federal_district: '',
          region_fias_id: '',
          region_kladr_id: '',
          region_iso_code: '',
          region_with_type: '',
          region_type: '',
          region_type_full: '',
          region: '',
          area_fias_id: '',
          area_kladr_id: '',
          area_with_type: '',
          area_type: '',
          area_type_full: '',
          area: '',
          city_fias_id: '',
          city_kladr_id: '',
          city_with_type: '',
          city_type: '',
          city_type_full: '',
          city: '',
          city_area: '',
          city_district_fias_id: '',
          city_district_kladr_id: '',
          city_district_with_type: '',
          city_district_type: '',
          city_district_type_full: '',
          city_district: '',
          settlement_fias_id: '',
          settlement_kladr_id: '',
          settlement_with_type: '',
          settlement_type: '',
          settlement_type_full: '',
          settlement: '',
          street_fias_id: '',
          street_kladr_id: '',
          street_with_type: '',
          street_type: '',
          street_type_full: '',
          street: '',
          house_fias_id: '',
          house_kladr_id: '',
          house_type: '',
          house_type_full: '',
          house: '',
          block_type: '',
          block_type_full: '',
          block: '',
          flat_type: '',
          flat_type_full: '',
          flat: '',
          flat_area: '',
          square_meter_price: '',
          flat_price: '',
          postal_box: '',
          fias_id: '',
          fias_code: '',
          fias_level: '',
          fias_actuality_state: '',
          kladr_id: '',
          geoname_id: '',
          capital_marker: '',
          okato: '',
          oktmo: '',
          tax_office: '',
          tax_office_legal: '',
          timezone: '',
          geo_lat: '',
          geo_lon: '',
          beltway_hit: '',
          beltway_distance: '',
          metro: '',
          qc_geo: '',
          qc_complete: '',
          qc_house: '',
          history_values: '',
          unparsed_parts: '',
          source: '',
          qc: ''
        }
      },
      WHERE_TO_FIND_US: '',
      REFFER: 'C сайта',
      SOURCE_OF_INCOME: '',
      PURPOSE_OF_THE_LOAN: '',
      FINANCIAL_POSITION: '',
      SmsConfCode: '',
      SmsConfCodeIu: '',
      ASP: false,
      INN: '',
      WORK_JOB_INN: '',
      WORK_JOB_PHONE: '+7 (',
      CONTACT: '',
      CONTACT_PHONE: '+7 (',
      CONTACT_STATUS: '',
      PAYMENT_TYPE: '',
      IU_FACE_AGREEMENT: false,
      SNILS: '',
      availablePeriods: '',
      finderBankSbp: '',
      pdlSmsConfCode: '',
      NOT_RELATED: true,
      MY_OWN_BENEFIT: true,
      ACTIONS_CONTROL: true,

      AGREEMENT_KI_REQUEST: false,

      THIRD_PARTIES: true,
      ACCEPTANCE_OF_THE_TERMS: true,
      AGREEMENT_WITH_THE_RULES: true,
      AGREEMENT_LONGATSIA_RULES: true,
      AGREEMENT_DATA_TRANSMISSION: true,
      REQURENT_PAY: true,
      GENERAL_TERMS_OF_MICROLOAN: false,
      PROCESSING_OF_PERSONAL_DATA: false,
      RULES_FOR_MICROLOAN: true,
      APPLICATION_MICROLOAN: true,
      AGREEMENT_IU: false,
      AGREEMENT_PDN: false,
      AGREEMENT_ANKETA: false,
      AGREEMENT_ALL: null,
      PROVIDING_MICROLOANS: false,
      CONSENT_TO_ADVERTISING: false,
      LOAN_WITH_INSURANCE: false,
      AGREEMENT_RECURENT: false,
      smartIdFileID: 0,
      LOAN_WITH_INSURANCE_PAYMENT_MODE: false,
      AGREEMENT_BOXES: true,
      ESIA: {},
      passport1: 0,
      passport2: 0,
      passport3: 0,
      selfImage: 0,
      BankAccount: 0,
      emptyValue: null,
      cdPayment: 'sbp',
      selectBindPayment: '',
      AGREEMENT_PDL_UI_CONSENT_TO_PD: true,
      AGREEMENT_PDL_UI_CONSENT_TO_ADVERT: true,
      AGREEMENT_PDL_UI_SIGN_LOAN: true,
      AGREEMENT_EASY_DRAFT_IU: false,
    },
    workData: {
      AVERAGE_EXPENSES_PER_MONTH: defaultRequriedFieldWorkData(),
      AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS: defaultRequriedFieldWorkData(),
      BIRTHDAY: defaultRequriedFieldWorkData(),
      BIRTHPLACE: defaultRequriedFieldWorkData(),
      CALC_SUMM: {code: 0, msg: '', ShowError: false},
      CALC_WEEK: {code: 0, msg: '', ShowError: false},
      CAR_NUMBER: {code: 0, msg: '', ShowError: false},
      IS_ASSIGNMENT_RIGHT: {code: 0, msg: '', ShowError: false},
      CONST_INCOME: defaultRequriedFieldWorkData(),
      CREDHISTORY_RADIO: {code: 0, msg: '', ShowError: false},
      EDUCATION: defaultRequriedFieldWorkData(),
      MARITAL_STATUS: defaultRequriedFieldWorkData(),
      MINOR_CHILDREN: {code: 0, msg: '', ShowError: false},
      EMAIL: defaultRequriedFieldWorkData(),
      EXPER_RADIO: defaultRequriedFieldWorkData(),
      FIRST_NAME: defaultRequriedFieldWorkData(),
      GENDER: defaultRequriedFieldWorkData(),
      IS_ADDRESS_COINCIDES: {code: 0, msg: '', ShowError: false},
      IS_I_CERTIFY_REGISTRATION: {code: 0, msg: '', ShowError: false},
      IS_I_CERTIFY_MARKETING: {code: 0, msg: '', ShowError: false},
      LAST_NAME: defaultRequriedFieldWorkData(),
      MEETING_DATE: defaultRequriedFieldWorkData(),
      MEETING_HOUR: defaultRequriedFieldWorkData(),
      OTHER_SOURCES_OF_INCOME: {code: 0, msg: '', ShowError: false},
      PASSPORT_DATE: defaultRequriedFieldWorkData(),
      PASSPORT_DEP: defaultRequriedFieldWorkData(),
      PASSPORT_DEP_CODE: defaultRequriedFieldWorkData(),
      PASSPORT_NUMBER: defaultRequriedFieldWorkData(),
      PASSPORT_SERIES: defaultRequriedFieldWorkData(),
      PHONE: defaultRequriedFieldWorkData(),
      PRODUCT_ID: {code: 0, msg: '', ShowError: false},
      REGISTRATION_ADDRESS: {
        code: 1,
        msg: 'обязательное поле, адрес нужно выбрать из выпадающего списка',
        ShowError: false
      },
      REGISTRATION_ADDRESS_DADATA: {code: 0, msg: 'обязательное поле', ShowError: false},
      RESIDENTIAL_ADDRESS: {
        code: 1,
        msg: 'обязательное поле, адрес нужно выбрать из выпадающего списка',
        ShowError: false
      },
      RESIDENTIAL_ADDRESS_DADATA: {code: 0, msg: 'обязательное поле', ShowError: false},
      SECOND_NAME: defaultRequriedFieldWorkData(),
      WORK_JOB: defaultRequriedFieldWorkData(),
      WORK_TITLE: defaultRequriedFieldWorkData(),
      WORK_TITLE_GIG_DATA: {code: 0, msg: '', ShowError: false},
      WORK_JOB_DADATA: {
        code: 0,
        msg: 'обязательное поле, место работы нужно выбрать из выпадающего списка',
        ShowError: false
      },
      WORK_JOB_ADRESS: {code: 0, msg: '', ShowError: false},
      WORK_JOB_ADRESS_DADATA: {code: 0, msg: 'обязательное поле', ShowError: false},
      WHERE_TO_FIND_US: {code: 0, msg: '', ShowError: false},
      REFFER: {code: 0, msg: '', ShowError: false},
      SmsConfCode: defaultRequriedFieldWorkData(),
      SmsConfCodeIu: defaultRequriedFieldWorkData(),
      AGREEMENT_ANKETA: defaultRequriedFieldWorkData(),
      SOURCE_OF_INCOME: defaultRequriedFieldWorkData(),
      PURPOSE_OF_THE_LOAN: defaultRequriedFieldWorkData(),
      FINANCIAL_POSITION: defaultRequriedFieldWorkData(),
      ASP: defaultRequriedFieldWorkData(),
      INN: {code: 0, msg: '', ShowError: false},
      WORK_JOB_INN: {code: 0, msg: '', ShowError: false},
      WORK_JOB_PHONE: defaultRequriedFieldWorkData(),
      CONTACT: defaultRequriedFieldWorkData(),
      CONTACT_PHONE: defaultRequriedFieldWorkData(),
      CONTACT_STATUS: defaultRequriedFieldWorkData(),
      PAYMENT_TYPE: defaultRequriedFieldWorkData(),
      tinkoffE2C_cardSelected: defaultRequriedFieldWorkData(),
      tinkoffA2C_bankSelected: defaultRequriedFieldWorkData(),
      IU_FACE_AGREEMENT: defaultRequriedFieldWorkData(),
      SNILS: defaultRequriedFieldWorkData(),
      finderBankSbp: {code: 0, msg: '', ShowError: false},
      pdlSmsConfCode: defaultRequriedFieldWorkData(),
      MY_OWN_BENEFIT: {code: 0, msg: '', ShowError: false},
      ACTIONS_CONTROL: {code: 0, msg: '', ShowError: false},
      NOT_RELATED: {code: 0, msg: '', ShowError: false},

      AGREEMENT_KI_REQUEST: {code: 0, msg: '', ShowError: false},

      THIRD_PARTIES: {code: 0, msg: '', ShowError: false},
      ACCEPTANCE_OF_THE_TERMS: {code: 0, msg: '', ShowError: false},
      AGREEMENT_WITH_THE_RULES: {code: 0, msg: '', ShowError: false},
      AGREEMENT_LONGATSIA_RULES: {code: 0, msg: '', ShowError: false},
      AGREEMENT_DATA_TRANSMISSION: {code: 0, msg: '', ShowError: false},
      REQURENT_PAY: {code: 0, msg: '', ShowError: false},
      GENERAL_TERMS_OF_MICROLOAN: {code: 0, msg: '', ShowError: false},
      RULES_FOR_MICROLOAN: {code: 0, msg: '', ShowError: false},
      APPLICATION_MICROLOAN: {code: 0, msg: '', ShowError: false},
      AGREEMENT_IU: defaultRequriedFieldWorkData(),
      AGREEMENT_PDN: defaultRequriedFieldWorkData(),
      AGREEMENT_RECURENT: defaultRequriedFieldWorkData(),

      LOAN_WITH_INSURANCE: {code: 0, msg: '', ShowError: false},
      smartIdFileID: {code: 0, msg: 'Обязательное поле', ShowError: false},

      LOAN_WITH_INSURANCE_PAYMENT_MODE: {code: 0, msg: '', ShowError: false},
      AGREEMENT_BOXES: {code: 0, msg: '', ShowError: false},
      ESIA: {code: 0, msg: '', ShowError: false},
      AGREEMENT_ALL: {code: 1, msg: 'Вы должны принять условия правил предоставления займов', ShowError: false},
      PROVIDING_MICROLOANS: defaultRequriedFieldWorkData(),
      PROCESSING_OF_PERSONAL_DATA: defaultRequriedFieldWorkData(),
      CONSENT_TO_ADVERTISING: defaultRequriedFieldWorkData(),
      passport1: defaultRequriedFieldWorkData(),
      passport2: defaultRequriedFieldWorkData(),
      passport3: defaultRequriedFieldWorkData(),
      selfImage: defaultRequriedFieldWorkData(),
      BankAccount: defaultRequriedFieldWorkData(),
      emptyValue: {code: 0, msg: '', ShowError: false},
      cdPayment: {code: 0, msg: '', ShowError: false},
      selectBindPayment: {code: 0, msg: '', ShowError: false},
      AGREEMENT_PDL_UI_CONSENT_TO_PD: {code: 0, msg: '', ShowError: false},
      AGREEMENT_PDL_UI_CONSENT_TO_ADVERT: {code: 0, msg: '', ShowError: false},
      AGREEMENT_PDL_UI_SIGN_LOAN: defaultRequriedFieldWorkData(),
      AGREEMENT_EASY_DRAFT_IU: defaultRequriedFieldWorkData(),
    },
    system: {
      loading: false,
      currentFormScreen: 'fio',
      scrMsg: 'Извините, произошел технический сбой. Наши специалисты уже занимаются решением проблемы. Попробуйте' +
        ' заполнить заявку позже.',
      isMobileAdressForm: false,

      guid: null,
      Partner_Id: null,

      // то, что ниже точно систем?
      onItsWay: false,
      // loanid:204058,
      loanDemandId: 0,
      loanid: 0,
      isPDL: false,
      DealProductType: false,
      pdlLimit: 0,
      loanLimit: 0,// заполняется при получении статуса по заявке, но где используется уже хз
      limitGetById: false,// результат бомбежки апи на уточнение лимита по заявке, параллельно заполнению экранов формы.
      limitValueFromAksiomatika: 0,/* todo нахрен от сюдова*/
      notTrimValues: ['REGISTRATION_ADDRESS', 'RESIDENTIAL_ADDRESS', 'PASSPORT_DEP', 'WORK_JOB', 'WORK_TITLE']
    },
    deal: {
      all: [],
      active: [],
      SaleForVirgin: false,
      /*значение лимита по доступной сумме для пользователя*/
      limitValue: 0,
      /*справочник возможных страховок от суммы продукта*/
      posibleDealWithInsurance: posibleDealWithInsurance()
    },
    mobileSuggestion: {
      REGISTRATION_ADDRESS: {
        area: '',
        city: '',
        street: '',
        house: '',
        deportament: '',
      },
      RESIDENTIAL_ADDRESS: {
        area: '',
        city: '',
        street: '',
        house: '',
        deportament: '',
      }
    },
    ref: [],
    addrTypes: [
      'RESIDENTIAL_ADDRESS',
      'REGISTRATION_ADDRESS',
    ],
  }
};

const TestSendData = () => {
  return {
    BIRTHDAY: '1986-12-24',
    BIRTHPLACE: 'фывфыв',
    CALC_SUMM: '22000',
    CALC_WEEK: '52',
    CAR_NUMBER: '',
    CONST_INCOME: '123',
    CREDHISTORY_RADIO: '123',
    EMAIL: '123',
    EXPER_RADIO: '123',
    FIRST_NAME: 'тест',
    GENDER: 'M',
    IS_ADDRESS_COINCIDES: 'N',
    IS_I_CERTIFY_REGISTRATION: 'Y',
    LAST_NAME: 'тест' + Math.random().toString(36).replace(/[^0-9]+/g, '').substr(0, 5),
    MEETING_DATE: '2020.12.12',
    MEETING_HOUR: '12:12',
    OTHER_SOURCES_OF_INCOME: '123123',
    PASSPORT_DATE: '2008-03-12',
    PASSPORT_DEP: '123123',
    PASSPORT_DEP_CODE: '111-11',
    PASSPORT_NUMBER: '111111',
    PASSPORT_SERIES: '1111',
    PHONE: '+7 (903) 207-38-48',
    PRODUCT_ID: 'S',
    REGISTRATION_ADDRESS: 'г Москва, ул Грина, д 5',
    REGISTRATION_ADDRESS_DADATA: {
      "value": "г Москва, ул Грина, д 5", "unrestricted_value": "117216, г Москва, ул Грина, д 5", "data": {
        "postal_code": "117216",
        "country": "Россия",
        "country_iso_code": "RU",
        "federal_district": null,
        "region_fias_id": "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
        "region_kladr_id": "7700000000000",
        "region_iso_code": "RU-MOW",
        "region_with_type": "г Москва",
        "region_type": "г",
        "region_type_full": "город",
        "region": "Москва",
        "area_fias_id": null,
        "area_kladr_id": null,
        "area_with_type": null,
        "area_type": null,
        "area_type_full": null,
        "area": null,
        "city_fias_id": "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
        "city_kladr_id": "7700000000000",
        "city_with_type": "г Москва",
        "city_type": "г",
        "city_type_full": "город",
        "city": "Москва",
        "city_area": null,
        "city_district_fias_id": null,
        "city_district_kladr_id": null,
        "city_district_with_type": null,
        "city_district_type": null,
        "city_district_type_full": null,
        "city_district": null,
        "settlement_fias_id": null,
        "settlement_kladr_id": null,
        "settlement_with_type": null,
        "settlement_type": null,
        "settlement_type_full": null,
        "settlement": null,
        "street_fias_id": "242912a9-7de3-4120-8bee-8dca086df20f",
        "street_kladr_id": "77000000000114000",
        "street_with_type": "ул Грина",
        "street_type": "ул",
        "street_type_full": "улица",
        "street": "Грина",
        "house_fias_id": "147f2281-ef84-4759-9b03-4562e4b7deb0",
        "house_kladr_id": "7700000000011400032",
        "house_type": "д",
        "house_type_full": "дом",
        "house": "5",
        "block_type": null,
        "block_type_full": null,
        "block": null,
        "flat_type": null,
        "flat_type_full": null,
        "flat": null,
        "flat_area": null,
        "square_meter_price": null,
        "flat_price": null,
        "postal_box": null,
        "fias_id": "147f2281-ef84-4759-9b03-4562e4b7deb0",
        "fias_code": null,
        "fias_level": "8",
        "fias_actuality_state": null,
        "kladr_id": "7700000000011400032",
        "geoname_id": null,
        "capital_marker": "0",
        "okato": "45293582000",
        "oktmo": "45906000",
        "tax_office": "7727",
        "tax_office_legal": "7727",
        "timezone": null,
        "geo_lat": null,
        "geo_lon": null,
        "beltway_hit": null,
        "beltway_distance": null,
        "metro": null,
        "qc_geo": null,
        "qc_complete": null,
        "qc_house": null,
        "history_values": null,
        "unparsed_parts": null,
        "source": null,
        "qc": null
      }
    },
    RESIDENTIAL_ADDRESS: 'г Москва, ул Грина, д 5',
    RESIDENTIAL_ADDRESS_DADATA: {
      "value": "г Москва, ул Грина, д 5", "unrestricted_value": "117216, г Москва, ул Грина, д 5", "data": {
        "postal_code": "117216",
        "country": "Россия",
        "country_iso_code": "RU",
        "federal_district": null,
        "region_fias_id": "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
        "region_kladr_id": "7700000000000",
        "region_iso_code": "RU-MOW",
        "region_with_type": "г Москва",
        "region_type": "г",
        "region_type_full": "город",
        "region": "Москва",
        "area_fias_id": null,
        "area_kladr_id": null,
        "area_with_type": null,
        "area_type": null,
        "area_type_full": null,
        "area": null,
        "city_fias_id": "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
        "city_kladr_id": "7700000000000",
        "city_with_type": "г Москва",
        "city_type": "г",
        "city_type_full": "город",
        "city": "Москва",
        "city_area": null,
        "city_district_fias_id": null,
        "city_district_kladr_id": null,
        "city_district_with_type": null,
        "city_district_type": null,
        "city_district_type_full": null,
        "city_district": null,
        "settlement_fias_id": null,
        "settlement_kladr_id": null,
        "settlement_with_type": null,
        "settlement_type": null,
        "settlement_type_full": null,
        "settlement": null,
        "street_fias_id": "242912a9-7de3-4120-8bee-8dca086df20f",
        "street_kladr_id": "77000000000114000",
        "street_with_type": "ул Грина",
        "street_type": "ул",
        "street_type_full": "улица",
        "street": "Грина",
        "house_fias_id": "147f2281-ef84-4759-9b03-4562e4b7deb0",
        "house_kladr_id": "7700000000011400032",
        "house_type": "д",
        "house_type_full": "дом",
        "house": "5",
        "block_type": null,
        "block_type_full": null,
        "block": null,
        "flat_type": null,
        "flat_type_full": null,
        "flat": null,
        "flat_area": null,
        "square_meter_price": null,
        "flat_price": null,
        "postal_box": null,
        "fias_id": "147f2281-ef84-4759-9b03-4562e4b7deb0",
        "fias_code": null,
        "fias_level": "8",
        "fias_actuality_state": null,
        "kladr_id": "7700000000011400032",
        "geoname_id": null,
        "capital_marker": "0",
        "okato": "45293582000",
        "oktmo": "45906000",
        "tax_office": "7727",
        "tax_office_legal": "7727",
        "timezone": null,
        "geo_lat": null,
        "geo_lon": null,
        "beltway_hit": null,
        "beltway_distance": null,
        "metro": null,
        "qc_geo": null,
        "qc_complete": null,
        "qc_house": null,
        "history_values": null,
        "unparsed_parts": null,
        "source": null,
        "qc": null
      }
    },
    SECOND_NAME: 'тест',
    WORK_JOB: 'asdasd',
    WORK_JOB_DADATA: {
      value: "", unrestricted_value: "", data: {
        kpp: "",
        capital: null,
        invalid: null,
        management: {name: "", post: "", disqualified: null},
        founders: null,
        managers: null,
        predecessors: null,
        successors: null,
        branch_type: "",
        branch_count: 0,
        source: null,
        qc: null,
        hid: "",
        type: "",
        state: {status: "", code: null, actuality_date: 0, registration_date: 0, liquidation_date: null},
        opf: {type: "", code: "", full: "", short: ""},
        name: {full_with_opf: "", short_with_opf: "", latin: null, full: "", short: ""},
        inn: "",
        ogrn: "",
        okpo: "",
        okato: "",
        oktmo: "",
        okogu: "",
        okfs: "",
        okved: "",
        okveds: null,
        authorities: null,
        documents: null,
        licenses: null,
        finance: {
          tax_system: null,
          income: null,
          expense: null,
          revenue: null,
          debt: null,
          penalty: null,
          year: null
        },
        address: {
          value: "", unrestricted_value: "", invalidity: null, data: {
            postal_code: "",
            country: "",
            country_iso_code: "",
            federal_district: "",
            region_fias_id: "",
            region_kladr_id: "",
            region_iso_code: "",
            region_with_type: "",
            region_type: "",
            region_type_full: "",
            region: "",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: "",
            city_kladr_id: "",
            city_with_type: "",
            city_type: "г",
            city_type_full: "",
            city: "",
            city_area: null,
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: "",
            city_district_type: "",
            city_district_type_full: "",
            city_district: "",
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: "",
            street_kladr_id: "",
            street_with_type: "",
            street_type: "",
            street_type_full: "",
            street: "",
            stead_fias_id: null,
            stead_cadnum: null,
            stead_type: null,
            stead_type_full: null,
            stead: null,
            house_fias_id: "",
            house_kladr_id: "",
            house_cadnum: "",
            house_flat_count: null,
            house_type: "",
            house_type_full: "",
            house: "",
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: null,
            flat_cadnum: null,
            flat_type: null,
            flat_type_full: null,
            flat: null,
            flat_area: "",
            square_meter_price: "",
            flat_price: null,
            room_fias_id: null,
            room_cadnum: null,
            room_type: null,
            room_type_full: null,
            room: null,
            postal_box: null,
            fias_id: "",
            fias_code: "",
            fias_level: "",
            fias_actuality_state: "",
            kladr_id: "",
            geoname_id: "",
            capital_marker: "",
            okato: "",
            oktmo: "",
            tax_office: "",
            tax_office_legal: "",
            timezone: "",
            geo_lat: "",
            geo_lon: "",
            beltway_hit: null,
            beltway_distance: null,
            metro: [{name: "", line: "", distance: 0}],
            divisions: null,
            qc_geo: "",
            qc_complete: null,
            qc_house: null,
            history_values: null,
            unparsed_parts: null,
            source: "",
            qc: ""
          }
        },
        phones: null,
        emails: null,
        ogrn_date: 0,
        okved_type: "",
        employee_count: null
      }
    },
    INN: '265775670593',
    WORK_JOB_INN: '265775670593'
  }
}

const state = getDefaultState();

const getters = {
  getRefValue: (state) => (target) => {
    let out = [];
    state.ref.forEach(item => {
      if (item.fieldName === target) {
        out = JSON.parse(JSON.stringify(item.fieldValues))
      }
    });

    return out.sort((a, b) => {
      return (a.sort !== undefined && b.sort !== undefined) ?
        parseInt(a.sort, 10) - parseInt(b.sort, 10)
        : 0;
    });
  },
  getTargetFieldValue: (state) => (target) => state.sendData['request'][target],
  isAdressValid: (state) => (target) => {
    if (state.sendData[target] == '' && state.sendData[target + '_DADATA'].value == '') {
      return 'Обязательное поле, Вы должны выбрать адрес из выпадающего списка';
    }

    if (state.sendData[target + '_DADATA'].value != state.sendData[target]) {
      return 'Вы должны выбрать адрес из выпадающего списка';
    }

    try {
      if (!state.sendData[target + '_DADATA'].data.house) {
        return 'Адрес не полный, укажите город, улицу и номер дома';
      }
    } catch (e) {
      return 'Адрес не корректный';
    }

    if (state.sendData[target + '_DADATA'].data.house_flat_count > 1) {
      if (state.sendData[target + '_DADATA'].data.flat >= 1) {
        return '';
      } else {
        return 'Адрес не полный, укажите город, улицу, номер дома и номер квартиры';
      }
    }
    //Если будут дополнительные проверки, помни выше отработает return в особых адресах.

    return '';
  },
  isJobValid: (state) => (target) => {
    if (state.sendData[target] == '' && state.sendData[target + '_DADATA'].value == '') {
      return 'Обязательное поле, Вы должны выбрать место работы из выпадающего списка';
    }

    if (state.sendData[target + '_DADATA'].value != state.sendData[target]) {
      return 'Вы должны выбрать место работы из выпадающего списка';
    }
    return '';
  },
  getMobileAdressSuggestion: (state) => (target) => {
    return state.mobileSuggestion[target].area + ' ' +
      state.mobileSuggestion[target].city + ' ' +
      state.mobileSuggestion[target].street + ' ' +
      state.mobileSuggestion[target].house + ' ' +
      state.mobileSuggestion[target].deportament;
  },
  fieldForCheckDublicateLead: (state) => {
    return {
      'SECOND_NAME': state.sendData.SECOND_NAME,
      'LAST_NAME': state.sendData.LAST_NAME,
      'FIRST_NAME': state.sendData.FIRST_NAME,
      'PHONE': state.sendData.PHONE,
    }
  },
  fieldForCheckPassportDublicateLead: (state) => {
    return {
      'REGISTRATION_ADDRESS': state.sendData.REGISTRATION_ADDRESS,
      'FIRST_NAME': state.sendData.FIRST_NAME,
      'LAST_NAME': state.sendData.LAST_NAME,
      'SECOND_NAME': state.sendData.SECOND_NAME,
      'PASSPORT_SERIES': state.sendData.PASSPORT_SERIES,
      'PASSPORT_NUMBER': state.sendData.PASSPORT_NUMBER,
      'BIRTHDAY': state.sendData.BIRTHDAY,
    }
  },
  getActiveDistinctPeriod: (state) => {
    //собирает уникальные значения сроков, для возможного выбора пользователем
    let distinctPeriod = [];
    let distinctPeriodShort = [];
    const arr = JSON.parse(JSON.stringify(state.deal.active));
    for (let i = 0; i < arr.length; i += 1) {
      if (distinctPeriodShort.indexOf(arr[i].loanPeriod) < 0 && arr[i].IsVisible == 1) {
        distinctPeriod.push({
          value: arr[i].loanPeriod,
          name: arr[i].loanPeriod + ' ' + arr[i].PeriodType
        });
        distinctPeriodShort.push(arr[i].loanPeriod)
      }
    }
    return distinctPeriod.sort((a, b) => {
      return a.value - b.value
    });
  },
  getActiveDistinctAmount: (state) => {
    //собирает уникальные значения сумм, для возможного выбора пользователем
    let distinctAmount = [];//массив объектов со значением суммы и приятным отображением в виде строки.
    let distinctAmountShort = [];//массив для проведения проверки
    const arr = JSON.parse(JSON.stringify(state.deal.active));
    for (let i = 0; i < arr.length; i += 1) {
      // intLoanAmount = parseInt(arr[i].Amount,10); если нужда заставит и хочется раскомментировать, то не здесь проблема!
      if (distinctAmountShort.indexOf(arr[i].Amount) < 0 && arr[i].IsVisible == 1) {
        distinctAmount.push({
          value: arr[i].Amount,
          name: arr[i].Amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        });
        distinctAmountShort.push(arr[i].Amount)
      }
    }
    return distinctAmount.sort((a, b) => {
      return a.value - b.value
    });
  },
  getActiveMinDeal: (state, getters) => {
    let minAmount = null;
    let stepValue;
    //получаем мин макс суммы для нового периода
    const arr = getters.getActiveDistinctAmount;
    for (let i = 0; i < arr.length; i += 1) {
      stepValue = parseInt(arr[i].value, 10);
      if (minAmount === null) {
        minAmount = stepValue
      } else if (minAmount > stepValue) {
        minAmount = stepValue
      }
    }
    return minAmount === null ? 0 : minAmount;
  },
  /**
   * вернет возможные суммы для страховки активной и неактивной
   * @param state
   * @param getters
   * @returns {{insuranseAmount: number, baseAmount: number}}
   */
  getActiveBoxDeal: (state, getters) => {
    if (getters.getSelectedDeal.vwIsPdl !== '1') {
      //если не пдл, то ниже написанное не имеет смысла
      return posibleDealWithInsuranceItem();
    }
    const Amount = getters.getSelectedDeal.Amount;
    const Period = getters.getSelectedDeal.loanPeriod;
    const InsuranceObj = state.deal.posibleDealWithInsurance[Amount];
    const psk = state.deal.active;
    // console.log(InsuranceObj)
    // console.log(Amount)
    /**
     * колдовство, которе проверяет есть ли в пск возможные варианты со страховкой
     * @returns {boolean}
     */
    const resultfindPsk = () => {
      let searchResult = -666;
      if (Array.isArray(psk) && psk.length > 0 && InsuranceObj !== undefined) {
        searchResult = handmadeSearch(psk, (item) => {
          const inArr = item.Amount + item.loanPeriod;
          const tryFind = Amount + Period;
          return inArr === tryFind
            ? 0
            : inArr < tryFind
              ? -1
              : 1;
        });
      }
      return searchResult >= 0;
    }

    return resultfindPsk() ? InsuranceObj : posibleDealWithInsuranceItem();
  },
  getActiveMaxDeal: (state, getters) => {
    let maxAmount = null;
    let stepValue;
    //получаем мин макс суммы для нового периода
    const arr = getters.getActiveDistinctAmount;
    for (let i = 0; i < arr.length; i += 1) {
      stepValue = parseInt(arr[i].value, 10);
      if (maxAmount === null) {
        maxAmount = stepValue
      } else if (maxAmount < stepValue) {
        maxAmount = stepValue
      }
    }
    return maxAmount === null ? 0 : maxAmount;
  },
  getActiveCalcSummIndex: (state, getters) => {
    const array = getters.getActiveDistinctAmount;
    let a = 0;
    let b = array.length - 1;
    const calcSumm = state.sendData.CALC_SUMM;

    return array.length > 0 ? searchCalcIndex(a, b, array, calcSumm) : 0;
    // return 0
  },
  getActiveCalcWeekIndex: (state, getters) => {
    let condition = getters.getActiveDistinctPeriod.length > 0;
    let i = 0;
    while (condition) {
      if (state.sendData.CALC_WEEK === getters.getActiveDistinctPeriod[i].value) {
        condition = false;
      }
      if (condition) {
        i += 1;
        condition = i < getters.getActiveDistinctPeriod.length;
      }
    }
    return i;
  },
  getSelectedDeal: (state) => {
    //объект по умолчанию, что бы компоненты не сходили с ума, пока данные идут и конвертятся с бека
    //Этот геттер нужен, что бы показывать информацию по выбранной сумме и сроку
    let objDeal = {
      /*сумма, которую выбрал пользователь*/
      Amount: 0,
      /*срок, который выбрал пользователь*/
      loanPeriod: 0,
      OutPayments: 0,
      rate: 0,
      payDay: '',
      FixedPay: 0,
      SaleForVirgin: state.deal.SaleForVirgin
    };
//todo а может бинарным поиском ебануть?
//     let step = 0;
//     let workFlag = true;
//     while (workFlag && state.deal.active.length > 0){
//       console.log(step,state.sendData.CALC_SUMM,state.sendData.CALC_WEEK)
//       console.log(state.deal.active[step].Amount,state.deal.active[step].loanPeriod)
//       console.log('-')
//       if (state.deal.active[step].Amount === state.sendData.CALC_SUMM
//         && state.deal.active[step].loanPeriod === state.sendData.CALC_WEEK){
//         objDeal = state.deal.active[step];
//         workFlag = false;
//       } else {
//         step += 1;
//       }
//       if (step > state.deal.active.length -1) {
//         workFlag = false;
//       }
//     }
    const Amount = state.sendData.CALC_SUMM;
    const Period = state.sendData.CALC_WEEK;
    const psk = state.deal.active;

    let searchResult = handmadeSearch(psk, (item) => {
      const inArr = item.Amount + item.loanPeriod;
      const tryFind = Amount + Period;
      return inArr === tryFind
        ? 0
        : inArr < tryFind
          ? -1
          : 1;
    });
    if (searchResult >= 0) {
      objDeal = psk[searchResult];
    }

    objDeal.SaleForVirgin = state.deal.SaleForVirgin;

    return objDeal;
  }
};

const actions = {
  saveRef: ({commit}, dataInput) => {
    if (Array.isArray(dataInput)) {
      dataInput.forEach((item) => {
        if (item.fieldName !== undefined && Array.isArray(item.fieldValues)) {
          commit('addDataInput', item);
        }
      });
    }
  },
  setMobileAdressSuggestion: ({commit}, requestFields) => {
    commit('saveMobileAdressSuggestion', requestFields);
  },
  setRequestField: ({dispatch}, requestFields) => {
    try {
      // console.log(requestFields)
      Object.keys(requestFields).forEach(function (key) {
        if (key in state.sendData) {
          if (requestFields[key] !== state.sendData[key] && requestFields[key] != '') {
            dispatch('saveSendData', {
              target: key,
              value: requestFields[key],
            });
          }
        }
      });
    } catch (e) {
      // console.log(e);
    }
  },
  setParamsDataUrl: ({dispatch}, requestFields) => {
    try {
      Object.keys(requestFields).forEach(key => {
        if (key in state.sendData) {
          dispatch('saveSendData', {
            target: key,
            value: requestFields[key],
          });
        }
      });
    } catch (err) {
      console.log('Set getparams vuex data', err);
    }
  },
  saveSendData: ({commit, getters, dispatch}, workArr) => {
    // if(process.env.NODE_ENV == 'development') {
    //   console.log(workArr);
    // }

    //если пришли кривые данные  не возбуждать state и еже с ним
    if (workArr.value === undefined) {
      return false;
    }

    if (state.workData[workArr.target].disable) {
      //если данные пришли с гос услуг, то редактирование поле заблокировано
      return false;
    }

    // workArr.value = transformValueBeforeSave(workArr);
    if (typeof workArr.value === 'string') {
      if (!state.system.notTrimValues.includes(workArr.target)) {
        // if (workArr.target !== 'REGISTRATION_ADDRESS' && workArr.target !== 'RESIDENTIAL_ADDRESS' && workArr.target !== 'PASSPORT_DEP') {
        workArr.value = workArr.value.trim();
      }
    }
    if (state.sendData[workArr.target] === workArr.value) {
      return false;
    }
    //даты блиять
    const dataArrFields = ['BIRTHDAY', 'PASSPORT_DATE'];
    const regExpData = /(\d{2})\.(\d{2})\.(\d{4})/;
    if (dataArrFields.includes(workArr.target)) {
      // console.log(workArr)
    }
    if (dataArrFields.includes(workArr.target) && workArr.value.length === 10 && !regExpData.test(workArr.value)) {
      let outD = new Date(workArr.value);
      workArr.value = (outD.getDate() < 10 ? '0' + outD.getDate() : outD.getDate())
        + '.' + (outD.getMonth() < 10 ? '0' + (outD.getMonth() + 1) : outD.getMonth() + 1)
        + '.' + outD.getFullYear();
    }


    //блок запуска колдунства над введенными буквами пользователя, принимает решение на сколько криво пользователь
    // воспользовался пальцами
    let statusArr = {};
    if (typeof FormFieldCheck[workArr.target] == 'function') {
      statusArr = FormFieldCheck[workArr.target](workArr.value);
    } else {
      statusArr = FormFieldCheck.isEmpty(workArr.value);
    }
    workArr['status'] = statusArr;

    if (process.env.NODE_ENV == 'development') {
      // console.log(workArr);
    }

    //todo переписать и найти решение, проблема как указать дерективу на инпут с уникальным шаблоном маски, если не каждому инпуту нужна такая директива.
    if (typeof FormFieldCheck[workArr.target + 'maskKostil'] == 'function') {
      workArr.value = FormFieldCheck[workArr.target + 'maskKostil'](workArr.value);
    }


    if (workArr.disable && !state.addrTypes.includes(workArr.target)) {
      //если при установке данных приходит признак блокировки поля для редактирования подпихиваем в объект статуса поля
      workArr.status.disable = true;
    }


//сохраняем значение и статус введеного
    commit('saveSendData', workArr);
    commit('saveWorkData', workArr);

    //особые поля особые костыли
    if (workArr.target === 'IS_ADDRESS_COINCIDES') {
      dispatch('isAdressConsides')
    }

    if (state.sendData.IS_ADDRESS_COINCIDES === 'Y') {
      let ind = state.addrTypes.findIndex((item) => {
        return item === workArr.target || item + '_DADATA' === workArr.target
      })

      if (ind >= 1) {
        state.addrTypes.reverse()
      }

      dispatch('saveAddr', {from: state.addrTypes[0], to: state.addrTypes[1]});
      dispatch('saveAddr', {from: state.addrTypes[0] + '_DADATA', to: state.addrTypes[1] + '_DADATA'});
    }

    if (workArr.target === 'CALC_SUMM') {
      dispatch('checkPeriodForCurrentCalcSumm');
    }
    if (workArr.target === 'CALC_WEEK') {
      dispatch('checkSummForCurrentPeriod');
    }

    if (workArr.target === 'WORK_JOB_DADATA') {
      if (workArr?.value?.data?.inn !== undefined) {
        commit('saveSendData', {
          target: 'WORK_JOB_INN',
          value: workArr?.value?.data?.inn
        });
      }
      if (workArr?.value?.data?.address !== undefined) {
        if (workArr?.value?.data?.address?.value !== undefined) {
          commit('saveSendData', {
            target: 'WORK_JOB_ADRESS',
            value: workArr?.value?.data?.address?.value
          });
        }
        if (workArr?.value?.data?.address?.data !== undefined) {
          commit('saveSendData', {
            target: 'WORK_JOB_ADRESS_DADATA',
            value: workArr?.value?.data?.address?.data
          });
        }
      }
    }

    // если прожали оплату страховку из своих, то выключаем галочку страховки
    if (workArr.target === 'LOAN_WITH_INSURANCE_PAYMENT_MODE') {
      if (workArr.value) {
        dispatch('saveSendData', {
          target: 'LOAN_WITH_INSURANCE',
          value: false
        });
      } else {
        dispatch('saveSendData', {
          target: 'LOAN_WITH_INSURANCE',
          value: true
        });
      }
    }

    if (workArr.target === 'LOAN_WITH_INSURANCE') {
      console.log('workArr.target === LOAN_WITH_INSURANCE');
      // console.log(workArr);
      if (state.sendData.LOAN_WITH_INSURANCE) {
        // если прожали страховку, то выключаем оплату из собственных средств
        console.log('если прожали страховку, то выключаем оплату из собственных средств');
        commit('saveSendData', {
          target: 'LOAN_WITH_INSURANCE_PAYMENT_MODE',
          value: false
        });
        if (getters.getActiveBoxDeal.baseAmount > 0) {
          commit('saveSendData', {
            target: 'CALC_SUMM',
            value: getters.getActiveBoxDeal.insuranseAmount
          });
        }
      } else {
        console.log('!если прожали страховку, то выключаем оплату из собственных средств');
        commit('saveSendData', {
          target: 'CALC_SUMM',
          value: getters.getActiveBoxDeal.baseAmount
        });
      }
    }

    if (workArr.target === 'WORK_TITLE') {
      commit('saveSendData', {
        target: 'WORK_TITLE_GIG_DATA',
        value: workArr.jsonSuggestion
      });
    }

    if (workArr.target === 'CONTACT_PHONE') {
      const clientPhone = state.sendData.PHONE.toString().replace(/[^.\d]+/g, "")
      const contactPhone = state.sendData.CONTACT_PHONE.toString().replace(/[^.\d]+/g, "")
      if (clientPhone.substring(clientPhone.length - 10) === contactPhone.substring(contactPhone.length - 10)) {
        commit('saveWorkData', {
          target: 'CONTACT_PHONE',
          status: {
            code: 10,
            msg: 'Номер телефона контактного лица не может совпадать с номером заемщика. Пожалуйста, укажите другой номер телефона',
            disable: false
          }
        });
        commit('saveErrorShow', {
          target: 'CONTACT_PHONE',
          value: true
        });
      }
    }

    if (workArr.target === 'SOURCE_OF_INCOME') {
      commit('changeWorkFields', workArr.value);
    }

    // if (workArr.target === 'AGREEMENT_EASY_DRAFT_IU') {
    //   const arrFields = ['AGREEMENT_IU', 'AGREEMENT_PDN', 'AGREEMENT_ANKETA', 'AGREEMENT_RECURENT'];
    //   arrFields.forEach(item => {
    //     dispatch('saveSendData', {
    //       target: item,
    //       value: workArr.value
    //     });
    //   });
    // }
  },
  resetToDefault: ({commit}) => {
    return new Promise(resolve => {
      commit('resetState');
      resolve();
    });
  },
  setTest: ({commit}) => {
    return new Promise(resolve => {
      commit('testData');
      resolve();
    });
  },
  isAdressConsides: ({dispatch}) => {
    if (state.sendData.IS_ADDRESS_COINCIDES === 'Y') {
      if (state.sendData.RESIDENTIAL_ADDRESS.length === 0) {
        state.addrTypes.reverse();
      }
      dispatch('saveAddr', {from: state.addrTypes[0], to: state.addrTypes[1]});
      dispatch('saveAddr', {from: state.addrTypes[0] + '_DADATA', to: state.addrTypes[1] + '_DADATA'});
    }
  },
  saveAddr({commit}, obj) {
    let workArr = {
      target: '',
      value: ''
    };
    let statusArr = {};

    workArr.target = obj.to;
    workArr.value = state.sendData[obj.from];

    if (typeof FormFieldCheck[workArr.target] == 'function') {
      statusArr = FormFieldCheck[workArr.target](workArr.value);
    } else {
      statusArr = FormFieldCheck.isEmpty(workArr.value);
    }

    workArr['status'] = statusArr;
    commit('saveSendData', workArr);
    commit('saveWorkData', workArr);
  },
  systemUpdate: ({commit}, valueObj) => {
    if (valueObj.target == undefined && valueObj.value == undefined) return false;
    commit('saveSystemData', valueObj);
  },
  errorShow: ({commit}, valueObj) => {
    if (valueObj.target == undefined && valueObj.value == undefined) return false;
    commit('saveErrorShow', valueObj);
  },
  showLoading: ({commit}) => {
    commit('saveSystemData', {
      target: 'loading',
      value: true,
    });
  },
  hideLoading: ({commit}) => {
    commit('saveSystemData', {
      target: 'loading',
      value: false,
    });
  },
  formRouting: ({commit}, target) => {
    commit('saveSystemData', {
      target: 'currentFormScreen',
      value: target
    });
  },
  fieldError: ({commit}, valueObj) => {
    if (valueObj.target == undefined && valueObj.value == undefined) return false;
    commit('saveErrorShow', {
      target: valueObj.target,
      value: true,
    });
    // commit('kostil', 1);
    commit('saveErrorMsg', valueObj);
  },
  // eslint-disable-next-line no-unused-vars
  getResultLoan: ({commit, dispatch}, iteration) => {
    // console.log('Run getResultLoan')
    return new Promise(((resolve, reject) => {
      if (state.system.loanid === 0) {
        // console.log('loanId - false');
        reject('loanid === 0');
        return false;
      }
      // console.log('Promise getResultLoan')
      myApi.SendRequest({
        action: 'CheckDecisionByID',
        typeRequest: 'loan',
        loandId: state.system.loanid
      }).then((res) => {
        // console.log('Rezult getResultLoan')
        if (res.onItsWay === 'true') {
          commit('saveSystemData', {
            target: 'DealProductType',
            value: res.DealProductType === 'true' ? true : false
          });
          commit('saveSystemData', {
            target: 'isPDL',
            value: res.isPDL === 'true' ? true : false
          });
          if (res.pdlLimit != undefined) {
            commit('saveSystemData', {
              target: 'pdlLimit',
              value: res.pdlLimit
            });
          }
          if (res.loanLimit != undefined) {
            commit('saveSystemData', {
              target: 'loanLimit',
              value: res.loanLimit
            });
          }
          if (res.demandid != undefined) {
            commit('saveSystemData', {
              target: 'loanDemandId',
              value: res.demandid
            });
          }

          commit('saveSystemData', {
            target: 'onItsWay',
            value: res.onItsWay === 'true' ? true : false
          });
          resolve(res);
        } else {
          switch (iteration.i) {
            case 1:
              iteration.time = 20000;
              break;
            case 2:
              iteration.time = 5000;
              break;
          }
          iteration.i += 1;
          setTimeout(() => {
            dispatch('getResultLoan', iteration)
              .then(res => resolve(res))
              .catch(res => reject(res));
          }, iteration.time);
        }
      }).catch((res) => {
        reject(res);
      })
    }));
  },
  deal23({commit, getters, dispatch}, dealArr) {
    if (Array.isArray(dealArr)) {
      dealArr.forEach((item) => {
        //если на беке не смогли в инт, для себя ценой пользователя конвертим
        item.Amount = parseInt(item.Amount, 10);
        item.loanPeriod = parseInt(item.loanPeriod, 10);
      });
      dealArr.sort((a, b) => {
        //так надо что бы потом найти читото в пск
        return (a.Amount + a.loanPeriod) - (b.Amount + b.loanPeriod)
      });

      //сохроняем все
      commit('setDealPskAll', dealArr);
      //Клон планировался для случаев когда по событиям часть продуктов скрываем.
      //Почему тут с json? Смотри гугл зачем так издеваются с объектом
      commit('setDealPskActive', JSON.parse(JSON.stringify(dealArr)));

      //заполняем справочники, для выпадающих списков select
      commit('addDataInput', {
        fieldName: 'CALC_SUMM',
        fieldValues: getters.getActiveDistinctAmount
      });
      commit('addDataInput', {
        fieldName: 'CALC_WEEK',
        fieldValues: getters.getActiveDistinctPeriod
      });

      //Дефолтные циферки, указанны Трифоновым. Если таких цифр нет,
      // то action планировлся с учетом и переведет цифры на доступные
      dispatch('saveSendData', {
        target: 'CALC_SUMM',
        value: 7000
      });
      dispatch('saveSendData', {
        target: 'CALC_WEEK',
        value: 14
      });
    } else {
      //Так, то пипец, ключевых данных нет.
      return false;
    }
  },
  setLimit({commit, getters, dispatch}, newLimit) {
    if (getters.getSelectedDeal.vwIsPdl == 1) {
      console.log('лимит старт')
      let limit = parseInt(newLimit, 10);
      let lastSumm = state.sendData.CALC_SUMM;
      if (lastSumm > limit) {
        // console.log(getters.getActiveMaxDeal)
        //если лимит отрезал на меньшую сумму, то пользователю ставим максимально доступную
        //не особо спрашивая его об этом.
        dispatch('saveSendData', {
          target: 'CALC_SUMM',
          value: limit
        });
      }
      if (!state.sendData.LOAN_WITH_INSURANCE) {
        //проверяем и пинаем галочку на состояние вкл
        dispatch('saveSendData', {
          target: 'LOAN_WITH_INSURANCE',
          value: true
        });
      } else {
        //галочка страховки уже включена, но надо продукт обновить, передергиваем
        dispatch('saveSendData', {
          target: 'LOAN_WITH_INSURANCE',
          value: false
        });
        dispatch('saveSendData', {
          target: 'LOAN_WITH_INSURANCE',
          value: true
        });
      }

      commit('setlimitGetById');
    }
    // запоминаем, что там за лимит приперся
    commit('setlimitValueFrom', newLimit);

  },
  dealOnlyPdl({commit, getters, dispatch}) {
    // if(state.deal.limitValue === 0) {// если лимит выставлен по апи шуршему в фоне, смысла нет отсекать не пдл продукты.
    let newDealArr = [];
    for (let i = 0; i < state.deal.all.length; i += 1) {
      if (state.deal.all[i].vwIsPdl == '1') {
        newDealArr.push(state.deal.all[i]);
      }
    }
    let lastSumm = state.sendData.CALC_SUMM;

    commit('setDealPskActive', newDealArr);
    commit('updateDataInput', {
      fieldName: 'CALC_SUMM',
      fieldValues: getters.getActiveDistinctAmount
    });
    commit('updateDataInput', {
      fieldName: 'CALC_WEEK',
      fieldValues: getters.getActiveDistinctPeriod
    });

    if (lastSumm > getters.getActiveMaxDeal) {
      dispatch('saveSendData', {
        target: 'CALC_SUMM',
        value: state.deal.limitValue === 0 ? getters.getActiveMaxDeal : state.deal.limitValue
      });
    }
    // }
  },
  checkPeriodForCurrentCalcSumm({commit, getters}) {

    let posibleDeal = [];
    for (let i = 0; i < state.deal.active.length; i += 1) {
      if (parseInt(state.deal.active[i].Amount, 10) === state.sendData.CALC_SUMM) {
        posibleDeal.push(state.deal.active[i]);
      }
    }
    posibleDeal.sort((a, b) => {
      return a.loanPeriod - b.loanPeriod;
    });
    //проверяем выбранный ранее пользователем период совпадает ли с новой суммой
    let chekInclude = false;
    if (getters.getActiveDistinctPeriod[getters.getActiveCalcWeekIndex] !== undefined) {
      for (let i = 0; i < posibleDeal.length; i += 1) {
        //для лююителей строго срванения, добавлено приведение к однуму типу
        if (parseInt(getters.getActiveDistinctPeriod[getters.getActiveCalcWeekIndex].value, 10) === parseInt(posibleDeal[i].loanPeriod, 10)) {
          chekInclude = true;
        }
      }
    }

    if (chekInclude) {
      return false;
    }

    if (!chekInclude && posibleDeal.length >= 1) {
      // console.log('повезло есть доступный период')
      //повезло есть доступный период
      commit('saveSendData', {
        target: 'CALC_WEEK',
        value: parseInt(posibleDeal[posibleDeal.length - 1].loanPeriod, 10)
      });
    }
  },
  checkSummForCurrentPeriod({commit}) {
    let minAmount = null;
    let maxAmount = null;
    let stepSumm;
    //state.sendData.CALC_SUMM
    //получаем мин макс суммы для нового периода
    //todo для каждого периода, можно знать мин макс заранее
    for (let i = 0; i < state.deal.active.length; i += 1) {
      stepSumm = parseInt(state.deal.active[i].Amount, 10);
//для лююителей строго срванения, добавлено приведение к однуму типу
      if (parseInt(state.deal.active[i].loanPeriod, 10) === parseInt(state.sendData.CALC_WEEK, 10)) {
        if (minAmount === null) {
          minAmount = stepSumm
        } else if (minAmount > stepSumm) {
          minAmount = stepSumm
        }
        if (maxAmount === null) {
          maxAmount = stepSumm
        } else if (maxAmount < stepSumm) {
          maxAmount = stepSumm
        }
      }
    }
    //если текущая сумма не попадает в новый период ставим новую возможную

    if (!(state.sendData.CALC_SUMM > minAmount && state.sendData.CALC_SUMM < maxAmount)) {
      // commit('pdlSetSelectedAmount',minAmount);
      commit('saveSendData', {
        target: 'CALC_SUMM',
        value: maxAmount
      });
    }
  },
  saveEsiaInfo({dispatch}, userInfo) {
    const passport = userInfo.documents.find(x => x.type === 'RF_PASSPORT' && x.relevance === 'actual')
    const stateInfo = {
      BIRTHDAY: userInfo.birthDate,
      BIRTHPLACE: userInfo.birthPlace,
      EMAIL: userInfo.email,
      FIRST_NAME: userInfo.firstName,
      GENDER: userInfo.gender,
      LAST_NAME: userInfo.lastName,
      PASSPORT_DATE: passport?.issueDate,
      PASSPORT_DEP: passport?.issuedBy,
      PASSPORT_DEP_CODE: passport?.issueId && passport?.issueId.length === 6 ? passport?.issueId.slice(0, 3) + '-' + passport?.issueId.slice(3) : passport?.issueId,
      PASSPORT_NUMBER: passport?.number,
      PASSPORT_SERIES: passport?.series,
      PHONE: userInfo.mobilePhone,
      REGISTRATION_ADDRESS: [
        userInfo.registrationAddress?.addressStr,
        userInfo.registrationAddress?.house,
        userInfo.registrationAddress?.frame,
        userInfo.registrationAddress?.flat
      ].filter(x => !!x)
        .join(`, `),
      RESIDENTIAL_ADDRESS: [
        userInfo.homeAddress?.addressStr,
        userInfo.homeAddress?.house,
        userInfo.homeAddress?.frame,
        userInfo.homeAddress?.flat
      ].filter(x => !!x)
        .join(`, `),
      SECOND_NAME: userInfo.middleName,
      INN: userInfo.inn,
      SNILS: userInfo.snils,
    }
    for (const key in stateInfo) {
      if (!stateInfo[key]) {
        continue;
      }
      dispatch('saveSendData', {
        target: key,
        value: stateInfo[key],
        disable: true // флаг, что поле заполнено и больше редактироваться не должно. требование Трифонова
      })
    }

    dispatch('saveSendData', {
      target: 'ESIA',
      value: userInfo,
    })
  }
};
//todo убрать лишние сохронялки в хранилише, проверять на совпадение новго и старого значения.
const mutations = {
  setlimitGetById: (state) => state.system.limitGetById = true,
  setSaleForVirgin: (state) => state.deal.SaleForVirgin = true,
  setDealPskAll: (state, value) => state.deal.all = value,
  setDealPskActive: (state, value) => state.deal.active = value,
  setActiveDealPsk: (state, value) => state.deal.active = value,
  setValuesToCheckbox: (state, newVal) => {
    state.sendData.THIRD_PARTIES =
      state.sendData.ACCEPTANCE_OF_THE_TERMS =
        state.sendData.AGREEMENT_WITH_THE_RULES =
          // state.sendData.AGREEMENT_LONGATSIA_RULES =
          // state.sendData.AGREEMENT_DATA_TRANSMISSION =
          //     state.sendData.AGREEMENT_KI_REQUEST =
          state.sendData.GENERAL_TERMS_OF_MICROLOAN =
            state.sendData.RULES_FOR_MICROLOAN =
              // state.sendData.APPLICATION_MICROLOAN =
              state.sendData.AGREEMENT_IU =
                state.sendData.REQURENT_PAY =
                  state.sendData.AGREEMENT_PDN =
                    // state.sendData.LOAN_WITH_INSURANCE =
                    state.sendData.AGREEMENT_RECURENT =
                      newVal;

    state.workData.THIRD_PARTIES =
      state.workData.ACCEPTANCE_OF_THE_TERMS =
        state.workData.AGREEMENT_WITH_THE_RULES =
          // state.workData.AGREEMENT_LONGATSIA_RULES =
          // state.workData.AGREEMENT_DATA_TRANSMISSION =
          //     state.workData.AGREEMENT_KI_REQUEST =
          state.workData.GENERAL_TERMS_OF_MICROLOAN =
            state.workData.RULES_FOR_MICROLOAN =
              // state.workData.APPLICATION_MICROLOAN =
              state.workData.AGREEMENT_IU =
                state.workData.REQURENT_PAY =
                  state.workData.AGREEMENT_PDN =
                    // state.workData.LOAN_WITH_INSURANCE =
                    state.workData.AGREEMENT_RECURENT =
                      (newVal) ? {code: 0, msg: ' ', ShowError: false} : {
                        code: 1,
                        msg: 'Обязательное поле',
                        ShowError: true
                      };
  },
  setDataInput: (state, newVal) => state.ref = newVal,
  addDataInput: (state, newVal) => state.ref.push(newVal),
  updateDataInput: (state, newVal) => {
    for (let i = 0; i < state.ref.length; i++) {
      if (newVal.fieldName === state.ref[i].fieldName) {
        state.ref[i].fieldValues = newVal.fieldValues
      }
    }

  },
  /**
   * сохранение значение поля формы в ебический объект формы
   * @param state
   * @param newVal object свойство target(название поля формы) value(значение поле формы) очень обязательное
   * @returns {*}
   */
  saveSendData: (state, newVal) => state.sendData[newVal.target] = newVal.value,
  saveWorkData: (state, newVal) => {
    state.workData[newVal.target].code = newVal.status.code;
    state.workData[newVal.target].msg = newVal.status.msg;
    state.workData[newVal.target].disable = newVal.status.disable;
  },
  kostil: (state, newVal) => state.workData.PHONE.code = newVal,
  saveErrorShow: (state, valueObj) => state.workData[valueObj.target].ShowError = valueObj.value,
  saveErrorMsg: (state, valueObj) => state.workData[valueObj.target].msg = valueObj.value,
  saveSystemData: (state, valueObj) => state.system[valueObj.target] = valueObj.value,
  resetState: (state) => Object.assign(state, getDefaultState()),
  testData: (state) => {
    Object.assign(state.sendData, TestSendData());
    for (let key in state.workData) {
      state.workData[key].code = 0
    }
  },
  saveScrMsg: (state, str) => state.system.scrMsg = str,
  selectAdressForm: (state) => {
    state.system.isMobileAdressForm = window.outerWidth < 760
  },
  saveMobileAdressSuggestion: (state, valueObj) => {
    state.mobileSuggestion[valueObj.target][valueObj.adresPart] = valueObj.value;
  },
  showThanks: (state) => state.system.currentFormScreen = 'scrEnd',
  setGuid: (state, newGuid) => state.system.guid = newGuid,
  setPartnerId: (state, newPartnerId) => state.system.Partner_Id = newPartnerId,
  setlimitValueFromAksiomatika: (state, value) => state.system.limitValueFromAksiomatika = value,
  setlimitValueFrom: (state, value) => state.deal.limitValue = value,
};


export default {
  state,
  getters,
  actions,
  mutations,
}
